import React from "react";
import { Link } from "react-router-dom";
import { Lines, ImgReveal } from "../components/Reveal";
import CategoryDeck from "./CategoryDeck";
import { useSiteImages } from "../lib/siteContent";

const TILES = [
    { label: "T-Shirts", to: "/shop?category=T-Shirts", slot: "category_tshirts", img: "/assets/CATEGORY_TSHIRTS.jpg", cls: "md:col-span-7 md:row-span-2 aspect-[3/4] md:aspect-auto" },
    { label: "Hoodies", to: "/shop?category=Hoodies", slot: "category_hoodies", img: "/assets/CATEGORY_HOODIES.jpg", cls: "md:col-span-5 aspect-square" },
    { label: "Jackets", to: "/shop?category=Jackets", slot: "category_jackets", img: "/assets/CATEGORY_JACKETS.jpg", cls: "md:col-span-5 aspect-square" },
    { label: "Bottoms", to: "/shop?category=Bottoms", slot: "category_bottoms", img: "/assets/CATEGORY_BOTTOMS.jpg", cls: "md:col-span-12 aspect-[16/9] md:aspect-[21/7]" },
];

export default function Categories() {
    const overrides = useSiteImages();
    return (
        <section data-testid="shop-by-category" className="mx-auto max-w-[1600px] px-5 py-24 sm:px-8 lg:px-16 lg:py-36">
            <p className="mb-3 text-[9px] uppercase tracking-[0.4em] text-[#6B6A66]">03 — Categories</p>
            <Lines
                lines={["Shop By Category"]}
                className="font-display mb-14 text-3xl font-extrabold uppercase tracking-tight text-[#0A0A0A] sm:text-5xl"
            />
            <CategoryDeck />
            <div className="hidden grid-cols-1 gap-4 md:grid md:grid-cols-12 lg:gap-6">
                {TILES.map((t, i) => (
                    <Link
                        key={t.label}
                        data-testid={`category-tile-${t.label.toLowerCase()}`}
                        data-cursor="SHOP"
                        to={t.to}
                        className={`group relative block overflow-hidden bg-[#ECEAE4] ${t.cls}`}
                    >
                        <ImgReveal
                            src={overrides[t.slot] || t.img}
                            alt={`${t.label} category`}
                            delay={i * 0.08}
                            className="absolute inset-0"
                            imgClassName="transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.05]"
                        />
                        <div className="absolute inset-0 bg-black/20 transition-colors duration-700 group-hover:bg-black/5" />
                        <span className="link-underline font-display absolute bottom-6 left-6 text-sm font-bold uppercase tracking-[0.25em] text-[#F2F0EA]">
                            {t.label}
                        </span>
                    </Link>
                ))}
            </div>
        </section>
    );
}
